import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {FreePlayDotIndicatorDefaultBox} from "./free-play-dot-indicator.default";
import {FreePlayDotIndicatorSIBox} from "./free-play-dot-indicator.si.box";

export const FreePlayDotIndicatorBox = styledByTheme(FreePlayDotIndicatorDefaultBox)
    .forSI(FreePlayDotIndicatorSIBox)
    .apply();